<h3 class="text-center bold">Banner</h3>
<app-json-viewer [model]="section"></app-json-viewer>
<p-orderList [value]="section.cards" controlsPosition="right">
    <ng-template let-card pTemplate="item">
        <div class="grid">
            <div class="col-6">
                <img [src]="card.imageUrl" style="height: 50px">
            </div>
            <div class="col-2">
                {{card.title ?? '-'}}
            </div>
            <div class="col-2">
                {{card.route ?? '-'}}
            </div>
            <div class="col-2">
                <div class="flex gap-2 justify-content-end">
                    <button type="button" pButton
                            icon="pi pi-pencil"
                            (click)="openEditDialog(card)"
                            class="p-button-info p-button-sm p-button-outlined z-1"></button>
                    <button type="button" pButton
                            icon="pi pi-trash"
                            class="p-button-danger p-button-sm p-button-outlined z-1"
                            (confirmDelete)="delete(card)"></button>
                </div>
            </div>
        </div>
    </ng-template>
</p-orderList>
<div class="flex justify-content-center gap-5 m-6">
    <button type="button" pButton
            label="Add New Banner"
            class="p-button-success w-12rem"
            (click)="add()"></button>

    <button type="button" pButton
            label="OK"
            class="p-button-primary w-12rem"
            (confirmSave)="closeDialog()"></button>
</div>

<p-dialog header="Edit card" [(visible)]="displayEditCard" [style]="{width: '80%', height: '80%'}">
    <ng-container *ngIf="editCard">
        <div class="grid">
            <div class="col-8">
                <form [formGroup]="formGroup">
                    <formly-form [model]="editCard" [fields]="fields" [form]="formGroup">
                    </formly-form>
                </form>
            </div>
            <div class="col-4">
                <app-route-select [(route)]="editCard.route"></app-route-select>
                <div class="text-xs text-red-300 text-center">
                    *** Copy the route and paste it in the route field ***
                </div>
            </div>
        </div>
        <div>{{editCard|json}}</div>
    </ng-container>
    <br>

    <p-footer>
        <button type="button" label="OK" class="prime-button" pButton="" (click)="closeEditDialog()"></button>&nbsp;
    </p-footer>
</p-dialog>
